<template>
  <v-data-table
    :loading="loading"
    :headers="getHeaders"
    :items="getTills"
    sort-by="end_date"
    :sort-desc="true"
    :mobile-breakpoint="0"
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 8"
    @page-count="pageCount = $event"
    :page.sync="page"
    :search="search"
  >
    <template v-slot:item.actions="{ item }">
      <v-row no-gutters aling="center" justify="end">
        <v-btn
          icon
          small
          @click="
            $router.push({
              name: 'TillEditor',
              params: { id: item.id }
            })
          "
        >
          <v-icon small>far fa-edit</v-icon>
        </v-btn>
      </v-row>
    </template>
    <template v-slot:item.start_date="{ item }">
      <span v-if="$vuetify.breakpoint.xsOnly">
        {{ item.start_date | denseDateFormat }}
      </span>
      <span v-else>
        {{ item.start_date | dateLocalFormat }}
      </span>
    </template>
    <template v-slot:item.end_date="{ item }">
      <span v-if="$vuetify.breakpoint.xsOnly">
        {{ item.end_date | denseDateFormat }}
      </span>
      <span v-else>
        {{ item.end_date | dateLocalFormat }}
      </span>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end">
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TillHistoryGrid",
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getTills"]),
    getHeaders() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          { text: "Date", value: "end_date" },
          { text: "Fait par", value: "signataire" },
          { text: "Écart caisse", value: "ecart_caisse" },
          { text: "", value: "actions" }
        ];
      } else {
        return [
          { text: "Début", value: "start_date" },
          { text: "Fin", value: "end_date" },
          { text: "Fait par", value: "signataire" },
          { text: "Commentaire", value: "commentaire" },
          { text: "Écart caisse", value: "ecart_caisse" },
          { text: "", value: "actions" }
        ];
      }
    }
  },
  data() {
    return {
      search: "",
      page: 1,
      pageCount: 0
    };
  }
};
</script>

<style lang="scss" scoped></style>
